__turbopack_context__.v({
  "hideOnMobile": "MainLayout-module__qvOIXq__hideOnMobile",
  "navbarOffset": "MainLayout-module__qvOIXq__navbarOffset",
  "navbarOffsetWithModules": "MainLayout-module__qvOIXq__navbarOffsetWithModules",
});
